var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1147_17458)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.571 18.3368C35.571 16.8619 35.4513 15.7856 35.1923 14.6694H18.3503V21.3264H28.2362C28.037 22.9808 26.9607 25.4722 24.5689 27.1463L24.5353 27.3692L29.8604 31.4945L30.2294 31.5313C33.6176 28.4021 35.571 23.7979 35.571 18.3368Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3504 35.8763C23.1936 35.8763 27.2595 34.2818 30.2294 31.5313L24.5689 27.1463C23.0541 28.2027 21.0211 28.9402 18.3504 28.9402C13.6068 28.9402 9.58066 25.811 8.14547 21.486L7.9351 21.5038L2.39797 25.7891L2.32556 25.9904C5.27536 31.8501 11.3345 35.8763 18.3504 35.8763Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.1455 21.4859C7.76681 20.3698 7.54765 19.1738 7.54765 17.9382C7.54765 16.7023 7.76681 15.5065 8.12558 14.3904L8.11554 14.1527L2.50903 9.79858L2.32559 9.88584C1.10983 12.3175 0.412231 15.0481 0.412231 17.9382C0.412231 20.8282 1.10983 23.5587 2.32559 25.9903L8.1455 21.4859Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3504 6.93605C21.7187 6.93605 23.9908 8.39102 25.2864 9.60692L30.3489 4.66392C27.2398 1.77389 23.1936 0 18.3504 0C11.3345 0 5.27536 4.02609 2.32556 9.88585L8.12555 14.3904C9.58066 10.0653 13.6068 6.93605 18.3504 6.93605Z",
    fill: "#EB4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1147_17458"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.3061dd6117b237c3df02c4ecc94c6cb2.svg";
export { ForwardRef as ReactComponent };